import sites from "config/sites"

const getAccessibleChannels = (user, site, locale) => {
    if (!user) return []

    // legacy: if no groups are attached to the user, then they can access all channels
    if (!user.oktaGroups?.length) return site.channels

    const accessibleChannels = site.channels.filter(channel => {
        const specialAccessGroups = channel.specialAccessGroups ? channel.specialAccessGroups.split(",") : []
        const groupsWithAccessToThisChannel = [
            ...specialAccessGroups,
            ...sites.global.adminOktaGroups,
            ...sites.global.premiumAccessOktaGroups,
            ...sites[locale].oktaGroupsGeneral,
        ]

        return groupsWithAccessToThisChannel.some(group => user.oktaGroups.includes(group))
    })

    return accessibleChannels
}

export { getAccessibleChannels }
